import { Capacitor, CapacitorHttp } from "@capacitor/core";
import _BaseAPIService from "../_BaseAPIService";
import { XMLParser } from "fast-xml-parser";

const apiService = _BaseAPIService.instance;

const ItemService = {
 


 listItem: async () => {
    try {
      let rawText;

      if (Capacitor.getPlatform() !== 'web') {
        // Native → CapacitorHttp bypasses CORS
        const response = await CapacitorHttp.post({
          url: `/Modules/ROI_Item/RoiItem.asmx/GetItemList`,
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          data: "", // empty string for .asmx POST
        });

        // Ensure rawText is a string (CapacitorHttp may parse automatically)
        rawText = typeof response.data === 'string' ? response.data : JSON.stringify(response.data);
      } else {
        // Web → fetch
        const response = await fetch(`/Modules/ROI_Item/RoiItem.asmx/GetItemList`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: "", // empty string for .asmx POST
        });

        rawText = await response.text();
      }

      // Parse XML to extract JSON string
      const parser = new XMLParser();
      const parsedXml = parser.parse(rawText);
      const innerText = parsedXml?.string || '';

      // Convert JSON string to JS object/array
      const jsonData = JSON.parse(innerText);

      return jsonData;
    } catch (error) {
      console.error('Error in listItem:', error);
      throw error;
    }
  },
};

export default ItemService;
